import { MaintenanceEventAttributes, MaintenanceEventState } from '@/types'
import { CreateMaintenanceEventMutation } from '../maintenance_event/__generated__/create_mutation'
import { Mutation as CreateMutation } from '../maintenance_event/create_mutation'
import { useForm } from '@/helpers/useForm'
import { Query as TableQuery } from '@/components/maintenance_event/table_query'

export const Form = () => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<CreateMaintenanceEventMutation, MaintenanceEventAttributes, never, never>({
    defaultValues: {
      assetId: '',
      maintenanceTypeId: '',
      startedAt: new Date,
      state: MaintenanceEventState.Started,
      tasks: []
    },
    mutation: CreateMutation,
    resultKey: 'createMaintenanceEvent',
    refetchQueries: [TableQuery]
  })

  return (
    <>
      <div>
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-2 gap-4">
          { formBuilder.buildField({ name: 'Asset', field: 'assetId', type: 'asset' }) }
          { formBuilder.buildField({ name: 'Maintanence type', field: 'maintenanceTypeId', type: 'maintenance-type' }) }
        </div>
        <div className="pt-6">
          { formBuilder.saveButton(save, mutationLoading, saveSuccess, 'Add') }
        </div>
      </div>
    </>
  )
}
